export default __webpack_public_path__ + "static/media/Original.15952313.png";